import { IMutations, IMutationsGrantAmendmentPayload, IMutationsGrantAmendmentDetailPayload } from './mutations.types'
import { INotification, IGrantAmendmentData, IGrantAmendment } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    /** refresh the state with amendment details */
    setGrantAmendment(state: IGrantAmendmentData, payload: IMutationsGrantAmendmentPayload): void {
        if (payload.grantAmendment) {
            state.grantAmendment = payload.grantAmendment;
            state.grantInfo = payload.grantInfo;
            state.amendmentRequests = payload.amendmentRequests;
            state.grantAmendmentDetailData = payload.amendmentDetailData
        }
    },
    /** refresh the state with amendment details */
    setGrantAmendmentDetail(state: IGrantAmendmentData, payload: IMutationsGrantAmendmentDetailPayload): void {
        if (payload.grantAmendmentDetail) {
            state.grantAmendmentDetail = payload.grantAmendmentDetail
            state.grantAmendmentDetailData = payload.grantAmendmentDetailData
            state.grantAmendment = payload.grantAmendment;
            state.grantInfo = payload.grantInfo;
            state.grantData = payload.grantData;
            state.schema = payload.schema;
            state.indicators = payload.indicators;
            state.allowCustomIndicator = payload.allowCustomIndicator;
        }
    },

    setGrantAmendmentDetailData(state: IGrantAmendmentData, payload: any) {
        state.grantAmendmentDetailData = payload;
    },

    setValidationMessages(state: IGrantAmendmentData, payload: any): void {
        if (payload && payload.length > 0) {
            state.showValidationDilog = true;
            state.validationMessages = payload;
        }
    },

    addIndicator(state: IGrantAmendmentData, payload: any): void {
        state.indicators.push(payload);
    },

    updateIndicator(state: IGrantAmendmentData, payload: any): void {
        var indicator = state.indicators.find( x => x.ID === payload.ID );
        var index = state.indicators.indexOf(indicator);
        state.indicators[index] = payload;
    },
}